'use client';

import { FC } from 'react';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { UserTopBarMenu } from '../DesktopTopHeaderBar/subcomponents/UserTopBarMenu/UserTopBarMenu';
import { Drawer } from '../../../common/components/Drawer/Drawer';
import { DrawerTriggerButton } from '../../../common/components/Drawer/DrawerTriggerButton';
import { RegularPersonWithAccountLevel } from '../Reusable/RegularPersonWithAccountLevel/RegularPersonWithAccountLevel';
import { useClientUserInfo } from '../../../common/userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';

const ProfileDrawer = () => {
  const { t } = useClientTranslation();

  const translations = {
    frequentlyAskedQuestions: t('frequently_asked_questions'),
    customerSupport: t('customer_support'),
    termsAndConditions: t('terms_and_conditions'),
    generalLogout: t('general_logout'),
    profile: t('general_profile'),
    twoFaWelcomeTitle: t('2fa_welcome_title'),
    twoFaResetTitle: t('2fa_reset_title'),
    reportsAndStatements: t('reports_and_statements'),
    legalDocumentation: t('legal_documentation'),
    cookies: t('cookies'),
    language: t('language'),
    errorSubtitle: t('info_toast_asset_unavailable_subtitle'),
    errorTitle: t('internal_error_headline'),
    englishSubtitle: t('select_language_en'),
    germanSubtitle: t('select_language_de'),
    arabicSubtitle: t('select_language_ar'),
    frenchSubtitle: t('select_language_fr'),
    // TODO add account level translations when available
    accountLevelUpgradeTitle: t('account_level_upgrade_title'),
    accountLevelUpgradeSubtitle: t('account_level_upgrade_subtitle'),
    yourAccount: t('your_account'),
    islamicBankingAccount: t('islamic_banking_account'),
    islamicBankingAccountDescription: t('islamic_banking_account_description'),
    islamicBankingAccountLearnMore: t('islamic_banking_account_learn_more'),
  };

  return (
    <Drawer>
      <UserTopBarMenu translatedValues={translations} />
    </Drawer>
  );
};

const MobileProfileMenu: FC = () => {
  const { isIslamicUser } = useClientUserInfo();

  return (
    <DrawerTriggerButton
      DrawerComponent={ProfileDrawer}
      drawerProps={{
        position: 'bottom',
        disableCloseButton: true,
      }}
    >
      <button type="button" data-testid="mobile-profile-menu-button">
        {isIslamicUser ? (
          <RegularPersonWithAccountLevel
            size={16}
            color="white"
            backgroundColor="brand.fill_primary"
          />
        ) : (
          <RegularPersonWithAccountLevel size={16} />
        )}
      </button>
    </DrawerTriggerButton>
  );
};

export { MobileProfileMenu };
